import request from "@utils/request";

/**
 * 首页
 * @returns {*}
 */
export function getImageList(data) {
    return request.post("/home/getImageList", data, {login: true});
}
export function getMImageList(data) {
    return request.post("/home/getMImageList", data, {login: true});
}
export function getTitValue(data) {
    return request.get("/home/getTitValue", data, {login: true});
}
export function getXXTList(data) {
    return request.get("/home/getXXTList", data, {login: false});
}
export function getJsApiTicket(data) {
    return request.get("/home/getJsApiTicket", data, {login: false});
}
export function err(data) {
    return request.get("/home/err", data, {login: false});
}
export function likeApi(data) {
    return request.post("/home/like", data, {login: true});
}
export function imageStatistics(data) {
    return request.post("/home/imageStatistics", data, {login: true});
}
export function uploadLesson(data) {
    return request.post("/home/uploadLesson", data, {login: true});
}
export function getActivity(data) {
    return request.get("/activity/getActivity?id="+data.id, data, {login: true});
}
export function getActivityM(data) {
    return request.get("/activity/getActivityM", data, {login: true});
}
export function getActivityMy(data) {
    return request.get("/activity/getActivityMy", data, {login: true});
}
export function searchActivity(data) {
    return request.get("/activity/searchActivity", data, {login: true});
}
export function getDicts(data) {
    return request.get("/activity/getDicts", data, {login: true});
}
export function signUp(data) {
    return request.post("/activity/signUp", data, {login: true});
}
export function uploadActivity(data) {
    return request.post("/activity/uploadActivity", data, {login: true});
}

